import { FiBriefcase } from "react-icons/fi";
import { DropdownField } from "components/dropdown-field";
import { PipelineEndpoints } from "../../../utils";
import { usePromiseData } from "hooks/use-promise-data";
import {
  FilterCard,
  FilterGrid
} from "components/pipeline-components/side-panel/components/FilterCard";
import { SidePanelAccordion } from "components/pipeline-components/side-panel/components/SidePanelAccordion";

interface RefinFieldsProps {
  value?: { bancos?: string[]; convenio?: string; codigoTabela?: string };
  onChange: (newValue: {
    bancos?: string[];
    convenio?: string;
    codigoTabela?: string;
  }) => void;
  mailingId?: number;
  isDisabled?: boolean;
}

export function RefinFields({
  value,
  onChange,
  mailingId,
  isDisabled
}: RefinFieldsProps) {
  const { result: bankOptions } = usePromiseData(() =>
    PipelineEndpoints.getBanksOptions(mailingId!)
  );

  return (
    <SidePanelAccordion
      icon={FiBriefcase}
      iconBgColor="#DBEAFE"
      iconColor="#2563EB"
      title="Banco"
      subtitle="Banco para o refinanciamento"
      activeCount={0}
    >
      <FilterGrid>
        <FilterCard label="Banco" isDisabled={isDisabled} fullWidth>
          <DropdownField
            options={bankOptions}
            dropdownProps={{
              w: "100%",
              variant: "filterInput",
              multiSelect: false,
              isDisabled
            }}
            value={value?.bancos?.[0] || ""}
            onChange={(newValue) => {
              onChange({
                ...value,
                bancos: newValue ? [newValue] : []
              });
            }}
          />
        </FilterCard>
      </FilterGrid>
    </SidePanelAccordion>
  );
}
